module.exports = __webpack_public_path__ + "img/ELLA_MAMA.717aa683.png";